<template>
  <div id="app">
    <router-view/>
    <!-- <CallarWindow v-if="$store.getters.activeCallerWindow"></CallarWindow> -->
  </div>
</template>
<script>
// import CallarWindow from '@/View/Twilio/callarWindow.vue'
export default {
  name: 'App',
  components: {
    // CallarWindow
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue